var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordPaymentWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6189_13674",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6189_13674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0592 8.18117C15.474 8.165 17.4845 10.1324 17.5061 12.5419C17.5276 15.0052 15.5387 17.0211 13.0861 17.0319C10.6767 17.0427 8.6769 15.0591 8.66612 12.6443C8.64994 10.1809 10.6012 8.19734 13.0592 8.17578V8.18117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1887 7.5018C5.82498 7.43712 4.50976 7.23768 3.28618 6.61781C2.95199 6.44532 2.62857 6.21893 2.36445 5.94942C1.87394 5.45352 1.90089 4.9684 2.3914 4.46711C2.84418 3.99816 3.41554 3.71786 4.01925 3.52382C6.27236 2.79613 8.5147 2.80692 10.7247 3.68013C11.1451 3.84723 11.5494 4.11135 11.8944 4.40242C12.4927 4.9091 12.4819 5.49664 11.9105 6.03566C11.2475 6.66632 10.4121 6.97895 9.53884 7.15683C8.76265 7.31853 7.97029 7.38322 7.18331 7.49641L7.1887 7.5018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45112 8.86178C8.17622 9.3469 7.92827 9.80507 7.66415 10.2525C7.62641 10.3118 7.53478 10.3764 7.46471 10.3818C5.99857 10.4142 4.57555 10.2255 3.24955 9.55173C3.0016 9.42237 2.76443 9.26605 2.54882 9.08817C2.04753 8.66235 1.94512 8.32815 2.04753 7.63281C4.03652 8.81327 6.20339 9.03427 8.44573 8.86717L8.45112 8.86178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3759 16.2282C8.00397 16.2498 7.659 16.2875 7.30863 16.2875C6.03115 16.2875 4.77522 16.1312 3.59477 15.6138C3.29291 15.479 3.00723 15.3065 2.72694 15.1286C2.16096 14.7567 1.89684 14.2392 2.03699 13.5547C2.44665 13.7487 2.85091 13.9697 3.27674 14.1368C4.5704 14.6435 5.91795 14.8376 7.29785 14.8052C7.51885 14.8052 7.62665 14.8645 7.72907 15.0747C7.91234 15.4628 8.13873 15.824 8.37051 16.2336L8.3759 16.2282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0493 10.5679C3.63941 11.5381 5.38046 11.84 7.19696 11.8615V13.3385C6.39921 13.3385 5.61763 13.2576 4.84143 13.069C4.08141 12.8911 3.35912 12.627 2.71768 12.1688C2.16788 11.7807 1.89837 11.274 2.0493 10.5625V10.5679Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordPaymentWhite);
export default __webpack_public_path__ + "static/media/record_payment_white.aeb1737b480193c6e192d997df0e74c9.svg";
export { ForwardRef as ReactComponent };